import gql from 'graphql-tag'

export default gql`
query labels($group: String!) {
  labels(
    sort: _ID_DESC
    limit: 10000
    filter: {
      group: $group
    }
  ) {
    _id
    referenceId
    seq
    last
    data
    recipient
    address
    app
    group
    tracking {
      _id
      carrier
      code
      sendHook
      scannedAt
      status
      sortCode
      dstStoreName
      sortingLineCode
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/labels.js